import api from './apiConfig';

const BASE_URL = '/queues';
const ACTIONS_URL = '/queue-actions';

const queueService = {
  // Queue operations
  getAll: async () => {
    try {
      const response = await api.get(BASE_URL);
      return response.data;
    } catch (error) {
      console.error('Error fetching queues:', error);
      throw error;
    }
  },

  getById: async (id) => {
    try {
      const response = await api.get(`${BASE_URL}/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching queue ${id}:`, error);
      throw error;
    }
  },

  create: async (data) => {
    try {
      const response = await api.post(BASE_URL, data);
      return response.data;
    } catch (error) {
      console.error('Error creating queue:', error);
      throw error;
    }
  },

  update: async (id, data) => {
    try {
      const response = await api.put(`${BASE_URL}/${id}`, data);
      return response.data;
    } catch (error) {
      console.error(`Error updating queue ${id}:`, error);
      throw error;
    }
  },

  delete: async (id) => {
    try {
      await api.delete(`${BASE_URL}/${id}`);
    } catch (error) {
      console.error(`Error deleting queue ${id}:`, error);
      throw error;
    }
  },

  getQueueTasks: async (queueId, page = 0, size = 10, sort = 'createdAt,desc', status = null) => {
    try {
      const response = await api.get(`/queues/${queueId}/tasks`, {
        params: {
          page: page,
          size: size,
          sort: sort,
          status: status
        },
      });
      return {
        tasks: response.data.content,
        pagination: {
          totalElements: response.data.totalElements,
          totalPages: response.data.totalPages,
          currentPage: response.data.number,
          pageSize: response.data.size,
          isFirst: response.data.first,
          isLast: response.data.last,
          isEmpty: response.data.empty,
          numberOfElements: response.data.numberOfElements
        }
      };
    } catch (error) {
      console.error(`Error fetching tasks for queue ${queueId}:`, error);
      throw error;
    }
  },

  // New method for getting completed tasks based on status
  getCompletedQueueTasks: async (queueId, page = 0, size = 10, sort = 'createdAt,desc', status = 'COMPLETED') => {
    try {
      const response = await api.get(`/queues/${queueId}/tasks/completed`, {
        params: {
          page: page,
          size: size,
          sort: sort,
          status: status
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching completed queue tasks:', error);
      throw error;
    }
  },

  // New count endpoint for tasks by status
  getQueueCount: async (queueId, status) => {
    try {
      const response = await api.get(`/queues/${queueId}/tasks-count`, {
        params: { status }
      });
      return response.data?.total ?? 0;
    } catch (error) {
      console.error(`Error fetching queue count for ${queueId} (${status}):`, error);
      throw error;
    }
  },
};

export default queueService; 
